import { IonContent, IonFooter, IonHeader } from '@ionic/react';
import { useMemo } from 'react';
import OrderMethodToolbar from '../../../modals/order-method/OrderMethodToolbar';
import MenuCategoryList from '../../../../../components-library/menu/MenuCategoryList';
import { ProductInterface } from '../../../../../services/exports/Interfaces';
import useBasket from '../../../../../hooks/basket/useBasket';
import CartIcon from '../../../assets/icons/CartIcon';
import ProfileToolbar from '../../../components/tool-bars/ProfileToolbar';
import useAuth from '../../../../../hooks/global/useAuth';
import Button from '../../../components/buttons/Button';
import useRouter from '../../../../../hooks/navigation/useRouter';
import { Modals, Routes } from '../../../exports/Enums';
import useModalRouter from '../../../common/hooks/useModalRouter';
import { useTranslation } from 'react-i18next';

export const MENU_TAB_CONTENT_ID = 'menuTabContentId';

const MenuTab = () => {
  const { items } = useBasket();
  const { t } = useTranslation(null, { keyPrefix: 'Modules:Mobile:Pages:Tabs:Menu:MenuTab' });
  const addedItemQuantity = useMemo(() => items?.reduce((acc, item) => acc + item.quantity, 0), [items]);
  const { isLoggedIn } = useAuth();
  const { navigate } = useRouter();
  const { openModal, closeModal } = useModalRouter();

  const onProductClick = (product: ProductInterface): void => {
    openModal({
      id: Modals.MenuItem,
      presentation: {
        initialBreakpoint: 1,
        breakpoints: [0, 1],
        handle: false,
      },
      props: {
        openModal: true,
        product: product,
        isFreeItem: product.discount === 100,
        onCloseModal: closeModal,
      },
    });
  };

  return (
    <>
      <IonContent
        scrollEvents={true}
        className="relative [&::part(scroll)]:bg-gray-500"
        id={MENU_TAB_CONTENT_ID}
        fullscreen
      >
        <IonHeader className="safe-area-top">
          <div className="py-sm bg-brand-primary/20">
            {isLoggedIn && <ProfileToolbar className="!stroke-black mr-md absolute right-0" />}
            <OrderMethodToolbar className="bg-white !border-mobile-notice  relative">
              <OrderMethodToolbar.CompanyName className="text-gray-700" />
              <OrderMethodToolbar.OrderMethodDetails className="text-black" />
            </OrderMethodToolbar>
          </div>
        </IonHeader>
        <MenuCategoryList onProductClick={onProductClick} />
      </IonContent>

      {!!items?.length && (
        <IonFooter className="pb-7 px-md bg-transparent">
          <Button
            className="relative"
            onClick={() =>
              navigate({
                mobile: {
                  path: Routes.Cart,
                },
              })
            }
          >
            <>
              <span className="absolute left-md">
                <CartIcon className="w-4 stroke-white" />
              </span>
              <span className="absolute right-md">{addedItemQuantity}</span>
              {t('buttons.place_order')}
            </>
          </Button>
        </IonFooter>
      )}
    </>
  );
};

export default MenuTab;
